import { render, staticRenderFns } from "./SelectManufacturer.vue?vue&type=template&id=efdd12a6&scoped=true&"
import script from "./SelectManufacturer.vue?vue&type=script&lang=js&"
export * from "./SelectManufacturer.vue?vue&type=script&lang=js&"
import style0 from "./SelectManufacturer.vue?vue&type=style&index=0&id=efdd12a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efdd12a6",
  null
  
)

export default component.exports